<template>
    <span>
        <div><i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>{{ message }}</div>
    </span>
</template>
    
<script>
export default{
    props: {
        message: {
            type: String,
            default: 'Cargando...'
        }
    }
}
</script>



// WEBPACK FOOTER //
// emt-loading.vue?19e057b7